import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Import from "../../../../assets/images/ic-Import.svg";
import ImportUser from "../../../../assets/images/imagesuser.png";
import ApiConfig from "../../../../api/ApiConfig";
import { simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const UsersReport = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [userAppType, setUserAppType] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [emailStatus, setEmailStatus] = useState("");
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    fetchReport();
  }, [userAppType, userStatus, emailStatus, OptionDownload]);

  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      user_app_type: userAppType,
      user_id: "",
      user_status: userStatus,
      email_status: emailStatus,
      pageid: "1",
      language: "en",
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(ApiConfig.USERS_REPORT, JSON.stringify(body))
      .then((res) => {
        if (res?.result) setOrderListData(res?.userapp || []);
        else setOrderListData([]);
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>{t("Users Report")}</p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Select User Type")}
                  value={userAppType}
                  onChange={(value) => setUserAppType(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Select User Type")}
                  </Option>
                  <Option value="transport_manager" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Transport Manager")}
                  </Option>
                  <Option value="fleet_manager" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Fleet Manager")}
                  </Option>
                  <Option value="driver" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Driver")}
                  </Option>
                  <Option value="customer" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Customer")}
                  </Option>
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "150px" }}
                  className="custom-select"
                  placeholder={t("Select User Status")}
                  value={userStatus}
                  onChange={(value) => setUserStatus(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Select User Status")}
                  </Option>
                  <Option value="active" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Active")}
                  </Option>
                  <Option value="inactive" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Inactive")}
                  </Option>
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Email Status")}
                  value={emailStatus}
                  onChange={(value) => setEmailStatus(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All Email Status")}
                  </Option>
                  <Option value="yes" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Verified")}
                  </Option>
                  <Option value="no" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Not Verified")}
                  </Option>
                </Select>
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (columns mapped to reference UI) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Image")}</th>
                  <th>{t("Username")}</th>
                  <th>{t("Email")}</th>
                  <th>{t("Contact Number")}</th>
                  <th>{t("Role")}</th>
                  <th>{t("Status")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={
                                item.user_profile_pic
                                  ? item.user_profile_pic
                                  : ImportUser
                              }
                              alt=""
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                          <td>
                            {item.user_name} {item.user_last_name}
                          </td>
                          <td>{item.user_email}</td>
                          <td>{item.user_mobile}</td>
                          <td>{item.user_role}</td>
                          <td>{item.user_status}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default UsersReport;
